import { render, staticRenderFns } from "./bg.vue?vue&type=template&id=73300cff"
import script from "./bg.vue?vue&type=script&lang=js"
export * from "./bg.vue?vue&type=script&lang=js"
import style0 from "./bg.vue?vue&type=style&index=0&id=73300cff&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports